import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=d12d26ec"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports